export enum Extras {
  GEO_NEWSLETTER = 'newsletter',
  GEO_LISTE = 'liste_eventi',
  ASSICURATA = 'ASSICURATA',
  FONDOGARANZIA = 'FONDOGARANZIA'
}
